<template>
  <v-app>
    <dashboard v-if="isLoggedIn"></dashboard>
    <auth v-else></auth>

    <v-snackbar v-model="notif.open" :color="notif.color" :timeout="2500">
      {{ notif.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" color="white" @click="notif.open = false">
          x
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import Dashboard from "@/components/Dashboard.vue";
import Auth from "@/components/Auth.vue";

export default {
  data() {
    return {
      notif: {
        open: false,
        message: "",
        color: "",
      },
      isLoggedIn: false,
    };
  },
  created() {
    this.renderApp();
    this.auth();
  },
  methods: {
    auth() {
      this.$root.app.xid = localStorage.getItem("xid");
      this.$root.app.xlevel = localStorage.getItem("xlevel");
      this.$root.app.isAdmin = this.$root.app.xlevel == "admin";
      this.isLoggedIn = this.$root.app.xid ? true : false;
      if (!this.isLoggedIn) {
        this.$router.replace("/login");
      }
    },
    renderApp() {
      const base_url = window.base_url
        ? window.base_url
        : "http://localhost:8000";
      const drive_url = window.drive_url
        ? window.drive_url
        : "http://localhost:5000";

      this.$root.app = {
        url: base_url,
        socket_url: window.socket_url,
        name: "SMKN 2 Jember",
        drive: {
          upload: (file) => {
            return fetch(drive_url + "/import.php", {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Headers": "*",
                "Access-Control-Allow-Methods": "*",
              },
              body: JSON.stringify({
                file: file,
              }),
            }).then((res) => res.json());
          },
        },
        http: {
          get: (path = "/", params = {}) => {
            const searchParams = new URLSearchParams();

            Object.keys(params).forEach((key) => {
              if (key !== "filters") {
                searchParams.append(key, params[key]);
              }
            });

            if (params.filters) {
              function buildParams(filterArray, parentKey = "filters") {
                filterArray.forEach((filter, index) => {
                  const keyPrefix = `${parentKey}[${index}]`;

                  if (filter.filters) {
                    // Jika ada nested filters, rekursif
                    searchParams.append(`${keyPrefix}[type]`, filter.type);
                    buildParams(filter.filters, `${keyPrefix}[filters]`);
                  } else {
                    // Tambahkan semua properti filter
                    searchParams.append(`${keyPrefix}[column]`, filter.column);
                    searchParams.append(
                      `${keyPrefix}[operator]`,
                      filter.operator
                    );
                    searchParams.append(`${keyPrefix}[value]`, filter.value);
                    if (filter.type) {
                      searchParams.append(`${keyPrefix}[type]`, filter.type);
                    }
                  }
                });
              }

              buildParams(params.filters);
            }

            const query = params ? "?" + searchParams.toString() : "";

            return fetch(base_url + path + query, {
              method: "GET",
            }).then((res) => res.json());
          },
          post: (path = "/", params = {}) => {
            return fetch(base_url + path, {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(params),
            }).then((res) => res.json());
          },
          put: (path = "/", params = {}) => {
            return fetch(base_url + path, {
              method: "PUT",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(params),
            }).then((res) => res.json());
          },
          del: (path = "/") => {
            return fetch(base_url + path, {
              method: "DELETE",
            }).then((res) => res.json());
          },
        },
        notif: (message = "", error = false) => {
          this.notif = {
            open: true,
            message: message,
            color: error ? "red" : "green",
          };
        },
        toBase64: (file, callback) => {
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            callback(reader.result);
          };
        },
      };
    },
  },
  components: {
    Dashboard,
    Auth,
  },
};
</script>
